const SPACING = 1400;
const MESH_HEIGHT = 900;
const MESH_WIDTH_VW = 50;

const BLOB_TEMPLATE = [
  { x: 0.78, y: 0.42, vx:  0.0007, vy:  0.0005, r: 255, g: 125, b: 60,  a: 0.95, rx: 0.66, ry: 0.30, angle: 0.3, phase: 0.0, freq: 0.20 },
  { x: 0.80, y: 0.52, vx: -0.0005, vy:  0.0008, r: 255, g: 125, b: 60,  a: 0.88, rx: 0.72, ry: 0.26, angle: 1.0, phase: 1.3, freq: 0.17 },
  { x: 0.75, y: 0.55, vx:  0.0008, vy: -0.0006, r: 241, g: 86,  b: 12,  a: 0.55, rx: 0.62, ry: 0.28, angle: 2.2, phase: 2.5, freq: 0.23 },
  { x: 0.82, y: 0.48, vx: -0.0006, vy:  0.0009, r: 255, g: 154, b: 108, a: 0.70, rx: 0.76, ry: 0.22, angle: 0.8, phase: 0.7, freq: 0.19 },
  { x: 0.76, y: 0.45, vx:  0.0005, vy: -0.0007, r: 241, g: 86,  b: 12,  a: 0.48, rx: 0.58, ry: 0.24, angle: 1.7, phase: 3.0, freq: 0.26 },
  { x: 0.79, y: 0.58, vx: -0.0007, vy:  0.0006, r: 255, g: 184, b: 153, a: 0.60, rx: 0.68, ry: 0.20, angle: 2.8, phase: 1.8, freq: 0.15 },
];

const MIN_X = 0.42, MAX_X = 0.92;
const MIN_Y = 0.22, MAX_Y = 0.78;

function initMesh(canvas, seed) {
  const ctx = canvas.getContext('2d');
  const blobs = BLOB_TEMPLATE.map((b, i) => ({
    ...b,
    phase: b.phase + seed * 0.37 + i * 0.11,
  }));

  let t = seed * 1.7;
  let running = false;
  let rafId = null;
  let cssW = 0;
  let cssH = 0;

  function resize() {
    const rect = canvas.getBoundingClientRect();
    if (rect.width === 0 || rect.height === 0) return;
    cssW = rect.width;
    cssH = rect.height;
    canvas.width = Math.max(1, Math.round(cssW * devicePixelRatio));
    canvas.height = Math.max(1, Math.round(cssH * devicePixelRatio));
  }
  resize();

  function drawBlob(p, W, H) {
    ctx.save();
    const cx = p.x * W;
    const cy = p.y * H;
    const angleShift = p.angle + Math.sin(t * p.freq * 0.5 + p.phase) * 0.35;
    ctx.translate(cx, cy);
    ctx.rotate(angleShift);
    const base = Math.max(W, H);
    const rw = p.rx * base;
    const rh = p.ry * base;
    ctx.scale(1, rh / rw);
    const aPulse = p.a * (0.90 + 0.10 * Math.sin(t * p.freq + p.phase));
    const grad = ctx.createRadialGradient(0, 0, 0, 0, 0, rw);
    grad.addColorStop(0,    `rgba(${p.r},${p.g},${p.b},${aPulse.toFixed(3)})`);
    grad.addColorStop(0.45, `rgba(${p.r},${p.g},${p.b},${(aPulse * 0.78).toFixed(3)})`);
    grad.addColorStop(0.78, `rgba(${p.r},${p.g},${p.b},${(aPulse * 0.24).toFixed(3)})`);
    grad.addColorStop(1,    `rgba(${p.r},${p.g},${p.b},0)`);
    ctx.fillStyle = grad;
    ctx.fillRect(-rw, -rw, rw * 2, rw * 2);
    ctx.restore();
  }

  function frame() {
    const W = canvas.width;
    const H = canvas.height;
    ctx.clearRect(0, 0, W, H);

    for (const p of blobs) {
      p.x += p.vx + Math.sin(t * p.freq       + p.phase) * 0.00040;
      p.y += p.vy + Math.cos(t * p.freq * 0.8 + p.phase) * 0.00040;
      if (p.x < MIN_X) { p.x = MIN_X; p.vx =  Math.abs(p.vx); }
      if (p.x > MAX_X) { p.x = MAX_X; p.vx = -Math.abs(p.vx); }
      if (p.y < MIN_Y) { p.y = MIN_Y; p.vy =  Math.abs(p.vy); }
      if (p.y > MAX_Y) { p.y = MAX_Y; p.vy = -Math.abs(p.vy); }
      drawBlob(p, W, H);
    }

    ctx.globalCompositeOperation = 'destination-out';

    const fadeLeft = ctx.createLinearGradient(0, 0, W * 0.55, 0);
    fadeLeft.addColorStop(0, 'rgba(0,0,0,1)');
    fadeLeft.addColorStop(1, 'rgba(0,0,0,0)');
    ctx.fillStyle = fadeLeft;
    ctx.fillRect(0, 0, W, H);

    const fadeTop = ctx.createLinearGradient(0, 0, 0, H * 0.32);
    fadeTop.addColorStop(0, 'rgba(0,0,0,1)');
    fadeTop.addColorStop(1, 'rgba(0,0,0,0)');
    ctx.fillStyle = fadeTop;
    ctx.fillRect(0, 0, W, H);

    const fadeBottom = ctx.createLinearGradient(0, H, 0, H * 0.68);
    fadeBottom.addColorStop(0, 'rgba(0,0,0,1)');
    fadeBottom.addColorStop(1, 'rgba(0,0,0,0)');
    ctx.fillStyle = fadeBottom;
    ctx.fillRect(0, 0, W, H);

    ctx.globalCompositeOperation = 'source-over';

    t += 0.015;
    if (running) rafId = requestAnimationFrame(frame);
  }

  return {
    start() {
      if (running) return;
      running = true;
      rafId = requestAnimationFrame(frame);
    },
    stop() {
      running = false;
      if (rafId) cancelAnimationFrame(rafId);
      rafId = null;
    },
    renderOnce() {
      frame();
    },
    resize,
  };
}

function build() {
  const { classList } = document.body;
  if (!classList.contains('page') && !classList.contains('single') && !classList.contains('archive')) return;

  const wrapper = document.createElement('div');
  wrapper.className = 'frontpage-mesh-field';
  wrapper.setAttribute('aria-hidden', 'true');
  document.body.appendChild(wrapper);

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const meshes = [];

  function currentDocHeight() {
    return Math.max(
      document.documentElement.scrollHeight,
      document.body.scrollHeight,
      document.documentElement.offsetHeight
    );
  }

  function ensureCount() {
    const docH = currentDocHeight();
    const targetCount = Math.max(0, Math.ceil((docH - SPACING - MESH_HEIGHT * 0.4) / SPACING));
    while (meshes.length < targetCount) {
      const i = meshes.length;
      const side = i % 2 === 0 ? 'right' : 'left';
      const canvas = document.createElement('canvas');
      canvas.className = `frontpage-mesh frontpage-mesh--${side}`;
      canvas.style.top = ((i + 1) * SPACING) + 'px';
      wrapper.appendChild(canvas);
      const mesh = initMesh(canvas, i);
      meshes.push({ canvas, mesh });

      if (reduceMotion) {
        mesh.renderOnce();
      } else {
        observer.observe(canvas);
      }
    }
  }

  const observer = !reduceMotion ? new IntersectionObserver((entries) => {
    for (const entry of entries) {
      const m = meshes.find((x) => x.canvas === entry.target);
      if (!m) continue;
      if (entry.isIntersecting) m.mesh.start();
      else m.mesh.stop();
    }
  }, { rootMargin: '200px' }) : null;

  ensureCount();

  let resizeTimer = null;
  window.addEventListener('resize', () => {
    if (resizeTimer) clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      for (const m of meshes) m.mesh.resize();
      ensureCount();
    }, 150);
  });

  const ro = new ResizeObserver(() => {
    ensureCount();
  });
  ro.observe(document.body);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', build);
} else {
  build();
}
